import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { Book, copyRestObject } from "../../../rest/models";
import { useEffect, useState } from "react";
import { BookReadComponent } from "./BookReadComponent";
import { bookReaderActions } from "./slice";
import { GetPageTitle } from "../../../ErnotsConfig";
import { RequestStatusDisplay } from "../../CommonComponents";
import { RequestStatus } from "../../../api_request/api_request";
import { downloadObject } from "../../../rest/data";
import { useLocation } from "react-router-dom";

export function BookRead()
{
    const appDispatch = useAppDispatch();
    const [bookRequest, setBookRequest] = useState<RequestStatus|undefined>(undefined);
    const location = useLocation();
    const bookId = new URLSearchParams(location.search).get('bookId');
    const book = useAppSelector(state => state.bookReader.book);

    let pageTitle = '';
    
    const hasData = bookRequest?.inState
        && bookRequest?.responseJson?.id === bookId
        && book.id === bookId;
    
    useEffect(function()
    {
        appDispatch(bookReaderActions.init());
        if (bookId)
        {
            downloadObject(Book, bookId, appDispatch, setBookRequest);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(function()
    {
        if (bookRequest?.inState)
        {
            appDispatch(bookReaderActions.setBook(copyRestObject(bookRequest.responseJson, Book)));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookRequest?.inState]);
    
    let ret = <></>;
    if (!bookId)
    {
        ret = <div>No book ID given.</div>;
    }
    else if (hasData)
    {
        pageTitle = `Reading "${book.title}"`;
        ret = <BookReadComponent isPreview={false}/>;
    }
    else
    {
        ret = <RequestStatusDisplay request={bookRequest} processing_message='Please wait, loading book data...'/>;
    }

    return (
    <div className='ernots_BookRead'>
        <title>{GetPageTitle(pageTitle)}</title>
        {ret}
    </div>);
}